module.exports = __webpack_public_path__ + "static/media/musical_nodes.cb90aee1.gif";